import React from 'react'
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import CloseCircle from '../icons/CloseCircle'
import ContainerHeading from '../layout/ContainerHeading'
import HelmetTitle from '../../components/layout/HelmetTitle'
import Moment from 'moment-timezone'
import GraphActionsBar from './GraphActionsBar'
import styledTheme from '../../styles/theme'
import axios from 'axios'

import GraphMenuItem from './controls/GraphMenuItem'
import GraphMenuContainer from './controls/GraphMenuContainer'
import GraphSettingsButton from './controls/GraphSettingsButton'
import GraphSettingsMenuItemsSet from './controls/GraphSettingsMenuItemsSet'

import GraphMinMaxWindow from './controls/GraphMinMaxWindow'
import GraphThresholdsWindow from './controls/GraphThresholdsWindow'
import GraphSettingsThresholdsSet from './controls/GraphSettingsThresholdsSet'

import { withStyles } from '@material-ui/core/styles'

import { DataViewModalContainer, ContainerHeadingActionIcon, GraphContentWrapper, GraphContainer } from './styled-elements'

const materialStyles = theme => ({
  dialogContent: {
    width: 320,
    paddingBottom: 0,
    paddingTop: '0 !important',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: '10px 0',
  },
  horizontalFields: {
    display: 'flex',
    flexDirection: 'row',
    margin: '10px 0',
  },
  selectField: {
    width: 200,
  },
  textField: {
    width: 80,
    margin: 5,
  },
})

class Graph extends React.Component {

  constructor(props) {
    super(props)
    const layoutWidth=this.getLayoutWdth()
    const layoutHeight=this.getLayoutHeight()
    const isSmallScreen=(layoutWidth < styledTheme.breakpoints.lg)
    const mobileLandscapeView=(isSmallScreen && (layoutWidth > layoutHeight))

    let yAxisMinMax = []
    let graphThresholdValues = {}

    const dataViewUpdatedAt = (props.dataView && new Date(props.dataView.updated_at))
    const yAxisMinMaxLocalUpdatedAtInt = localStorage.getItem(`yAxisMinMax_${this.props.dataView.id}_updated_at`)
    const yAxisMinMaxLocalUpdatedAt = (yAxisMinMaxLocalUpdatedAtInt && new Date(parseInt(yAxisMinMaxLocalUpdatedAtInt)))
    const graphThresholdValuesLocalUpdatedAtInt = localStorage.getItem(`graphThresholdValues_${this.props.dataView.id}_updated_at`)
    const graphThresholdValuesLocalUpdatedAt = (graphThresholdValuesLocalUpdatedAtInt && new Date(parseInt(graphThresholdValuesLocalUpdatedAtInt)))

    if (yAxisMinMaxLocalUpdatedAt && dataViewUpdatedAt && (yAxisMinMaxLocalUpdatedAt > dataViewUpdatedAt)) {
      yAxisMinMax = JSON.parse(localStorage.getItem(`yAxisMinMax_${props.dataView.id}`))
    } else if (dataViewUpdatedAt && props.dataView.y_axes) {
      yAxisMinMax = props.dataView.y_axes.map((axis) => {
        return {
          unitKey: axis.unit_key,
          min: axis.min,
          max: axis.max,
          inverted: axis.inverted,
        }
      })
    } else {
      yAxisMinMax = props.options.yAxis.map((axis) => {
        return {
          unitKey: axis.unitKey,
          symbol: axis.title.text,
          min: axis.min,
          max: axis.max,
        }
      })
    }

    if (graphThresholdValuesLocalUpdatedAt && dataViewUpdatedAt && (graphThresholdValuesLocalUpdatedAt > dataViewUpdatedAt)) {
      graphThresholdValues = JSON.parse(localStorage.getItem(`graphThresholdValues_${props.dataView.id}`))
    } else if (dataViewUpdatedAt && props.dataView.thresholds) {
      graphThresholdValues = props.dataView.thresholds
    }

    this.state = {
      layoutWidth,
      layoutHeight,
      isSmallScreen,
      mobileLandscapeView,
      graphSettingsMenuVisible: false,
      setGraphMinMaxWindowVisible: false,
      yAxisMinMax: yAxisMinMax,
      origYAxisMinMax: null,
      graphThresholdValues: graphThresholdValues,
      origThresholdValues: null,
    }
    this.graphContainerDiv = React.createRef()
    this.highChartsChart = React.createRef()
  }

  getLayoutWdth = () => {
    if (typeof window === 'undefined') return styledTheme.breakpoints.lg
    return window.innerWidth
  }

  getLayoutHeight = () => {
    if (typeof window === 'undefined') return (styledTheme.breakpoints.lg*9/16)
    return window.innerHeight
  }

  formatSeries = (seriesArray) => seriesArray.map(series => {
    if (series.yAxis==='y_axis_percent' && series.offset_enabled) {
      return {
        ...series,
        tooltip: {
          pointFormatter: function() {
            return '<span style="color:' + this.color + '">\u25CF</span> ' + series.name + ' <b>' + (this.y+series.offset).toFixed(2) + '%</b><br/>'
          }
        }
      }
    }
    return series
  })

  processOptions = (options,props,state) => {
    const mobileDisplayOptions = {}
    if (state.layoutWidth < styledTheme.breakpoints.lg) {
      mobileDisplayOptions['scrollbar'] = { enabled: false }
      //mobileDisplayOptions['legend'] = { enabled: false }
      //mobileDisplayOptions['rangeSelector'] = { enabled: false }
      const xAxis = { ...options['xAxis'] }
      const maxUnixTimeMoment = Moment(new Date(xAxis[0]['max']))
      const monthAgoUnixtime = maxUnixTimeMoment.clone().subtract(1,'M')
      const xAxisRange = maxUnixTimeMoment.diff(monthAgoUnixtime)
      xAxis['range'] = xAxisRange
      xAxis['startOnTick'] = false
      xAxis['endOnTick'] = false
      xAxis['ordinal'] = false
      mobileDisplayOptions['xAxis'] = xAxis
    }
    options.chart['height'] = this.state.chartContainerHeight-20 || "100%";
    options.chart['width'] = this.state.chartContainerWidth-20 || 300;

    const percentAxis = options.yAxis.find(axis => axis.unitKey==='percent')
    if (percentAxis && (percentAxis.labels && (percentAxis.labels['enabled']!==undefined) && (percentAxis.labels['enabled']===false))) {
      options.rangeSelector['x'] = 30
    }

    const locallySavedYAxisMinMaxJson = localStorage.getItem(`yAxisMinMax_${props.dataView.id}`)
    if (locallySavedYAxisMinMaxJson) {
      const locallySavedYAxisMinMax = JSON.parse(locallySavedYAxisMinMaxJson)
      console.log('locallySavedYAxisMinMax',locallySavedYAxisMinMax)
      options.yAxis.forEach(axis => {
        const unitKey = axis.unitKey
        console.log('unitKey',unitKey)
        const locallySavedItem = locallySavedYAxisMinMax.find(item => item.unitKey==unitKey)
        console.log('locallySavedItem',locallySavedItem)
        axis['min'] = locallySavedItem.min
        axis['max'] = locallySavedItem.max
      })
    }

    const locallySavedGraphThresholdsJson = localStorage.getItem(`graphThresholdValues_${props.dataView.id}`)
    const offset = options.series[0].offset_enabled ? options.series[0].offset : 0
    if (locallySavedGraphThresholdsJson) {
      const locallySavedGraphThresholds = JSON.parse(locallySavedGraphThresholdsJson)
      // console.log('XXX locallySavedGraphThresholds',locallySavedGraphThresholds)
      const axis = options.yAxis.find(axis => {
        // console.log('XXX axis.unitKey',axis.unitKey)
        // console.log('XXX locallySavedGraphThresholds.unit_key',locallySavedGraphThresholds.unit_key)
        return (axis.unitKey===locallySavedGraphThresholds.unit_key)
      })
      if (!axis) return
      if (axis && axis.plotBands && axis.plotBands.length) {
        const plotBand = axis.plotBands[0]
        plotBand['from'] = locallySavedGraphThresholds['refill_point'] - offset
        plotBand['to'] = locallySavedGraphThresholds['full_point'] - offset
      } else if (locallySavedGraphThresholds['full_point'] && locallySavedGraphThresholds['refill_point']) {
        const newPlotBand = {
          color: "rgba(68, 170, 213, 0.2)",
          from: locallySavedGraphThresholds['refill_point'] - offset,
          to: locallySavedGraphThresholds['full_point'] - offset,
        }
        if (typeof axis.plotBands==="object") {
          axis.plotBands.push(newPlotBand)
        } else {
          axis['plotBands'] = [ newPlotBand ]
        }
      }
      if (locallySavedGraphThresholds['stress_point']) {
        const stressLine = axis.plotLines && axis.plotLines.find(plotLine => (plotLine.label && (plotLine.label.text==="Stress")))
        if (stressLine) {
          stressLine['value'] = locallySavedGraphThresholds['stress_point'] - offset
        } else {
          const newStressLine = {
            color: "rgba(255, 112, 102, 1)",
            dashstyle: "Dash",
            label: { text: "Stress", align: "right", x: -10, y: 16 },
            value: locallySavedGraphThresholds['stress_point'] - offset,
            width: 2,
          }
          if (typeof axis.plotLines==="object") {
            axis.plotLines.push(newStressLine)
          } else {
            axis['plotLines'] = [ newStressLine ]
          }
        }
      }
    }

    //console.log('options',options)

    return {
      ...options,
      ...mobileDisplayOptions,
      series: this.formatSeries(options.series.slice()),
      time: {
        getTimezoneOffset: function (timestamp) {
          return -Moment.tz(timestamp, options.time.timezone).utcOffset()
        }
      }
    }
  }

  last3Heights = []
  last3Widths = []

  resizeHandler = (e) => {

    //console.log('XXX resizeHandler',e)

    this.last3Heights = []
    this.last3Widths = []

    const resizeFunction = () => {
      // console.log('XXX resizeFunction')
      // console.log('XXX e.target.innerWidth',e.target.innerWidth)
      // console.log('XXX e.target.layoutWidth',e.target.layoutWidth)
      // console.log('XXX e.target.innerHeight',e.target.innerHeight)
      // console.log('XXX e.target.layoutHeight',e.target.layoutHeight)
      if ((e.target.innerWidth===this.state.layoutWidth) && (e.target.innerHeight===this.state.layoutHeight)) return
      const layoutWidth=this.getLayoutWdth()
      const layoutHeight=this.getLayoutHeight()
      const isSmallScreen=(layoutWidth < styledTheme.breakpoints.lg)
      const mobileLandscapeView=(isSmallScreen && (layoutWidth > layoutHeight))
      // console.log('XXX this.graphContainerDiv.current.offsetHeight',this.graphContainerDiv.current.offsetHeight)
      // console.log('XXX this.graphContainerDiv.current.offsetWidth',this.graphContainerDiv.current.offsetWidth)
      this.setState({
        chartContainerHeight: this.graphContainerDiv.current.offsetHeight,
        chartContainerWidth: this.graphContainerDiv.current.offsetWidth,
        layoutWidth,
        layoutHeight,
        isSmallScreen,
        mobileLandscapeView,
      })
    }

    // To handle animated screen re-sizing and delayed updating of window.innerWidth in Mobile Chrome:
    // Run this function 3 times, and only when the height and width have been stable for 3 seconds,
    // stop calling resizeFunction

    const intervalId = setInterval(() => {
      this.last3Widths.push(e.target.innerWidth)
      this.last3Heights.push(e.target.innerHeight)
      this.last3Widths = this.last3Widths.slice(-3)
      this.last3Heights = this.last3Heights.slice(-3)
      // console.log("XXX this.last3Widths",this.last3Widths)
      // console.log("XXX this.last3Heights",this.last3Heights)
      if ((this.last3Widths.length < 3) || (this.last3Heights.length < 3)) {
        resizeFunction()
      } else {
        const widthTotal = this.last3Widths.reduce((n,total) => total+n,0)
        const heightTotal = this.last3Heights.reduce((n,total) => total+n,0)
        if (((widthTotal/3)===this.last3Widths[2]) && ((heightTotal/3)===this.last3Heights[2])) {
          resizeFunction()
          clearInterval(intervalId)
        } else {
          resizeFunction()
        }
      }
    },1000)
  }

  addDataPoint = (seriesId,dataPoint) => {
    const chart = this.highChartsChart.current.chart
    const series = chart.get(seriesId)
    series.addPoint(dataPoint)
    const xAxis = series.xAxis
    const yAxis = series.yAxis
    console.log('dataPoint',dataPoint)
    xAxis.setExtremes(Math.min(xAxis.min,dataPoint[0]),Math.max(xAxis.max,dataPoint[0]))
    yAxis.setExtremes(Math.min(yAxis.min,dataPoint[1]),Math.max(yAxis.max,dataPoint[1]))
  }

  componentDidMount = () => {
    this.removeHighchartsCredit.call(this)
    const container = this.highChartsChart.current.container.current;
    container.style.height = "100%";
    container.style.width = "100%";
    container.style.border = "2px solid red;"
    if (this.highChartsChart.current.chart) {
      this.highChartsChart.current.chart.reflow()
      this.updateChartContainerDimensions()
    }
    window.addEventListener('resize', this.resizeHandler)
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeHandler)
  }

  componentDidUpdate = (previousProps, previousState) => {
    const updateHash = {}
    this.updateChartContainerDimensions()
    if (this.highChartsChart.current.chart) {
      this.highChartsChart.current.chart.setSize(
        this.state.chartContainerWidth,
        this.state.chartContainerHeight,
      )
      this.highChartsChart.current.chart.reflow()
    }
    if (this.props.options!==previousProps.options) {
      const yAxisMinMax = this.props.options.yAxis.map((axis) => {
        return {
          unitKey: axis.unitKey,
          symbol: axis.title.text,
          min: axis.min,
          max: axis.max,
        }
      })
      updateHash['yAxisMinMax'] = yAxisMinMax
    }
    if (this.props.dataView!==previousProps.dataView) {
      const thresholdsSet = GraphSettingsThresholdsSet(this.props.dataView.data_view_type_key)
      if (thresholdsSet) {
        updateHash['graphThresholdUnitKey'] = thresholdsSet.unitKey
      }
    }
    if (Object.keys(updateHash).length) this.setState(updateHash)
  }

  graphSettingsButtonClickHandler = () => {
    this.setState({ graphSettingsMenuVisible: !this.state.graphSettingsMenuVisible })
  }

  graphSettingsOverlayClickHandler = (event) => {
    if (event.target === event.currentTarget) {
      this.setState({ graphSettingsMenuVisible: false })
    }
  }

  graphSettingsMenuSetGraphMinMaxClickHandler = () => {
    const origYAxisMinMax = this.state.yAxisMinMax.map(item => ({ ...item }))
    this.setState({
      setGraphMinMaxWindowVisible: true,
      graphSettingsMenuVisible: false,
      origYAxisMinMax: origYAxisMinMax,
    })
  }

  setGraphMinMaxWindowInputChangeHandler = (e) => {

    const name = e.target.name
    const value = e.target.value

    const nameArray = name.split(':')
    const unitKey = nameArray[0]
    const bound = nameArray[1]

    const yAxisMinMax = this.state.yAxisMinMax

    const yAxisObject = yAxisMinMax.find((axis) => axis.unitKey===unitKey)
    yAxisObject[bound] = parseFloat(value)

    this.setState({ yAxisMinMax })

  }

  setGraphMinMaxWindowSaveButtonClickHandler = () => {
    localStorage.setItem(`yAxisMinMax_${this.props.dataView.id}`,JSON.stringify(this.state.yAxisMinMax))
    localStorage.setItem(`yAxisMinMax_${this.props.dataView.id}_updated_at`,new Date().getTime())
    this.setState({ setGraphMinMaxWindowVisible: false })
    this.props.updateDataViewConfigHashHandler({ y_axes: this.state.yAxisMinMax.map(axis => ({ unit_key: axis.unitKey, min: axis.min, max: axis.max }))})
  }

  setGraphMinMaxWindowCancelButtonClickHandler = () => {
    this.setState({
      setGraphMinMaxWindowVisible: false,
      yAxisMinMax: [...this.state.origYAxisMinMax],
    })
  }

  graphSettingsMenuSetGraphThresholdsClickHandler = () => {
    const origThresholdValues = { ...this.state.graphThresholdValues }
    this.setState({
      setGraphThresholdsWindowVisible: true,
      graphSettingsMenuVisible: false,
      origThresholdValues: origThresholdValues,
    })
  }

  setGraphThresholdsWindowInputChangeHandler = (e) => {

    const name = e.target.name
    const value = e.target.value

    const graphThresholdValues = this.state.graphThresholdValues

    graphThresholdValues[name] = parseFloat(value)

    this.setState({ graphThresholdValues })

  }

  setGraphThresholdsWindowSaveButtonClickHandler = () => {
    this.setState({ setGraphThresholdsWindowVisible: false })
    const thresholdsSet = GraphSettingsThresholdsSet(this.props.dataView.data_view_type_key)
    const params = { thresholds: { ...this.state.graphThresholdValues, unit_key: (thresholdsSet ? thresholdsSet.unitKey : null) } }
    this.props.updateDataViewConfigHashHandler(params)
    localStorage.setItem(`graphThresholdValues_${this.props.dataView.id}`,JSON.stringify(params.thresholds))
    localStorage.setItem(`graphThresholdValues_${this.props.dataView.id}_updated_at`,new Date().getTime())
  }

  setGraphThresholdsWindowCancelButtonClickHandler = () => {
    this.setState({
      setGraphThresholdsWindowVisible: false,
      graphThresholdValues: { ...this.state.origThresholdValues },
    })
  }

  graphSettingsMenuMenuButtonShouldDisplay = () => {

    switch (this.props.dataView.data_view_type_key) {
      case 'graph_all_sensors':
      case 'graph_soil_profile_probe_moisture':
      case 'graph_soil_profile_probe_temperature':
      case 'graph_soil_profile_probe_ec':
      case 'graph_sdi12_moisture_rootzone_average_plus_discrete_lower':
      case 'graph_sdi12_moisture_average':
      case 'graph_sdi12_moisture_sum':
      case 'graph_tension':
      case 'graph_custom':
        return true
      default:
        return false
    }

  }

  updateChartContainerDimensions() {
    if (
      (this.graphContainerDiv) &&
      (this.graphContainerDiv.current) &&
      (
        (this.state.chartContainerHeight!==this.graphContainerDiv.current.offsetHeight) ||
        (this.state.chartContainerWidth!==this.graphContainerDiv.current.offsetWidth)
      )
    ) {
        this.setState({
          chartContainerHeight: this.graphContainerDiv.current.offsetHeight,
          chartContainerWidth: this.graphContainerDiv.current.offsetWidth,
        })
    }
  }

  removeHighchartsCredit = () => {
    const highchartsCreditElArray = document.querySelectorAll('.highcharts-credits')
    if (highchartsCreditElArray.length) {
      const highchartsCredit = highchartsCreditElArray[0]
      highchartsCredit.parentNode.removeChild(highchartsCredit)
    }
  }

  renderBody = (props,state) => {

    const { site, dataView, options, includeGraphActions } = props
    let processedOptions = this.processOptions(options,props,state)

    const HighchartsObj = <GraphContentWrapper>
      <GraphContainer innerRef={this.graphContainerDiv}>
        <HighchartsReact
          ref={this.highChartsChart}
          highcharts={Highcharts}
          constructorType={'stockChart'}
          options={processedOptions}
          allowChartUpdate={true}
        />
      </GraphContainer>

      <GraphSettingsButton
        available={this.graphSettingsMenuMenuButtonShouldDisplay()}
        clickHandler={this.graphSettingsButtonClickHandler}
      />
      <GraphMenuContainer
        available={this.graphSettingsMenuMenuButtonShouldDisplay()}
        visible={this.state.graphSettingsMenuVisible}
        overlayClickHandler={this.graphSettingsOverlayClickHandler}
      >
        <GraphSettingsMenuItemsSet
          dataViewType={dataView.data_view_type_key}
          setGraphMinMaxClickHandler={this.graphSettingsMenuSetGraphMinMaxClickHandler}
          setThresholdClickHandlers={this.graphSettingsMenuSetGraphThresholdsClickHandler}
          enableDisableSeriesClickHandler={this.graphSettingsMenuEnableDisableSeriesClickHandler}
        />
      </GraphMenuContainer>
      <GraphMinMaxWindow
        available={this.graphSettingsMenuMenuButtonShouldDisplay()}
        visible={this.state.setGraphMinMaxWindowVisible}
        yAxisMinMax={this.state.yAxisMinMax}
        inputErrors={this.state.setGraphMinMaxInputErrors || {}}
        inputChangeHandler={this.setGraphMinMaxWindowInputChangeHandler}
        cancelBtnClickHandler={this.setGraphMinMaxWindowCancelButtonClickHandler}
        saveButtonClickHandler={this.setGraphMinMaxWindowSaveButtonClickHandler}
        materialStyles={props.classes}
      />
      <GraphThresholdsWindow
        available={this.graphSettingsMenuMenuButtonShouldDisplay()}
        visible={this.state.setGraphThresholdsWindowVisible}
        dataViewType={dataView.data_view_type_key}
        thresholdDisplayType={'band'}
        thresholdValues={this.state.graphThresholdValues}
        inputErrors={this.state.setGraphThresholdsInputErrors || {}}
        inputChangeHandler={this.setGraphThresholdsWindowInputChangeHandler}
        cancelBtnClickHandler={this.setGraphThresholdsWindowCancelButtonClickHandler}
        saveButtonClickHandler={this.setGraphThresholdsWindowSaveButtonClickHandler}
        materialStyles={props.classes}
      />

    </GraphContentWrapper>

    const title = site ? `${site.name}: ${dataView.name}` : dataView.name

    return <DataViewModalContainer>
      <HelmetTitle title={title} />
      {(state.mobileLandscapeView===false) && <ContainerHeading
        title={title}
        actionIcons={
          <ContainerHeadingActionIcon onClick={this.props.closeDataViewHandler}><CloseCircle /></ContainerHeadingActionIcon>
        }
      />}
      {(state.mobileLandscapeView===false) && includeGraphActions && <GraphActionsBar
        manualInputFormOpenHandler={props.manualInputFormOpenHandler}
      />}
      {HighchartsObj}

    </DataViewModalContainer>
  }

  render = () => this.renderBody(this.props,this.state)

}

export default withStyles(materialStyles)(Graph)



// WEBPACK FOOTER //
// ./src/components/dataViews/Graph.js